/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { connect } from 'react-redux';
import {
    number, object, string, bool,
} from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import { getDataDictionary } from '../../../../../../state/ducks/App/App-Selectors';

const styles = (theme) => ({
    productCountContainer: {
        position: 'relative',
        marginLeft: 'auto',
    },
    plaWrapper: {
        position: 'absolute',
        right: 0,
        lineHeight: '36px',
    },
    productCountContainerMobile: {
        marginLeft: '0',
    },
    productCountText: {
        color: theme.palette.text.primary,
        fontSize: '16px',
        fontWeight: 400,
    },
    plaProductCountText: {
        color: theme.palette.text.primary,
        fontSize: '16px',
        fontWeight: 400,
        margin: '0',
    },
});

const ProductCount = ({
    totalCount, classes, ssrDeviceType, language, dataDictionary = {}, withFilter, brand,
}) => (
    <>
        { brand?.code === 'CAN'
            ? (
                <div className={ssrDeviceType === 'mobile' ? classes.productcountContainerMobile : (withFilter && classes.productCountContainer)}>
                    { brand?.code === 'CAN'
                        ? (
                            <p className={classes.productCountText}>
                                {language === '/en' ? `Showing ${totalCount || 0} products` : `${dataDictionary.Showing} ${totalCount || 0} ${dataDictionary.products}`}
                            </p>
                        ) : (
                            <p className={classes.productCountText}>
                                { `${totalCount || 0} items` }
                            </p>
                        )}
                </div>
            ) : (
                <div className={classes.plaWrapper}>
                    <p className={classes.plaProductCountText}>
                        { `${totalCount || 0} items` }
                    </p>
                </div>
            )}
    </>
);

const mapStateToProps = (state) => ({
    dataDictionary: getDataDictionary(state),
});

ProductCount.propTypes = {
    totalCount: number.isRequired,
    classes: object.isRequired,
    ssrDeviceType: string.isRequired,
    dataDictionary: object.isRequired,
    language: string.isRequired,
    withFilter: bool.isRequired,
    brand: string.isRequired,
};

export default connect(mapStateToProps)(withStyles(styles)(ProductCount));
